import { render } from "./knowledgeBase.vue?vue&type=template&id=4045b199"
import script from "./knowledgeBase.vue?vue&type=script&lang=js"
export * from "./knowledgeBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__